import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { ApolloProvider, ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import './index.css'

const client = new ApolloClient({
	// link: new HttpLink({
	uri: 'https://maschinenbau-dunder.myshopify.com/admin/api/2022-01/graphql.json',
	cache: new InMemoryCache(),
	// fetchOptions: {
	//   mode: 'no-cors'
	// }
	// }),
})

// DEV-Only Guard für falsche Cleanups:
if (process.env.NODE_ENV !== 'production') {
	const React = require('react')
	const originalUseEffect = React.useEffect
	React.useEffect = (fn, deps) => {
		return originalUseEffect(() => {
			const cleanup = fn()
			if (cleanup !== undefined && typeof cleanup !== 'function') {
				// Wo kommt es her?
				// Stack liefert dir die aufrufende Komponente:
				// eslint-disable-next-line no-console
				console.error(
					'Cleanup ist KEINE Funktion:',
					cleanup,
					new Error('CleanupTrace').stack
				)
				// kein Cleanup zurückgeben -> React ruft nichts auf
				return undefined
			}
			return cleanup
		}, deps)
	}
}

ReactDOM.render(
	// <React.StrictMode>
	<ApolloProvider client={client}>
		<App />
	</ApolloProvider>,
	// </React.StrictMode>,
	document.getElementById('root')
)
